<template>
    <b-card no-body class="mb-1">
        &nbsp;
        <b-table
            striped
            responsive
            :fields="detailFields"
            :items="localObjects"
            stacked="md"
            show-empty
            :empty-text="$t('com_geen_data', { ns: 'common' })"
            small
        >
            <template v-slot:cell(actions)="row">
                <div class="form-inline">
                    <b-button
                        v-if="checkRight('AnalyticsEntityObjectCreate')"
                        size="sm"
                        @click="bewerkItem(row.item)"
                        class="bgc_aux_warning"
                        ><font-awesome-icon icon="edit" size="1x" />
                    </b-button>
                    <b-button
                        v-if="checkRight('AnalyticsEntityObjectDelete')"
                        size="sm"
                        @click="verwijderItem(row.item)"
                        class="bgc_aux_alarm"
                        ><font-awesome-icon icon="trash-alt" size="1x" />
                    </b-button>
                </div>
            </template>
        </b-table>
        <modal-executor
            v-if="detailsVisible"
            :inType="selectedExecutor.typenaam"
            :inID="selectedExecutor.id"
            v-model="detailsVisible"
            @hide="reset"
            @forcerefresh="changed"
        />
    </b-card>
</template>

<script>
import { Permission } from '../../models/Permissions';
import ModalExecutor from './ModalExecutor.vue';
import { loadItem } from './utils';
export default {
    name: 'ExecutorInfo',
    data: function () {
        return {
            detailsVisible: false,
            selectedExecutor: null
        };
    },
    model: {
        prop: 'visible',
        event: 'changed'
    },
    props: {
        inItems: {
            type: Array,
            required: true
        }
    },
    components: {
        ModalExecutor
    },
    watch: {},
    computed: {
        detailFields() {
            const fieldsInit = [
                { key: 'actions', label: ' ', visible: true },
                {
                    key: 'barcode',
                    label: this.$t('com_barcode', { ns: 'common' }),
                    sortable: true,
                    visible: true
                },
                {
                    key: 'naam',
                    label: this.$t('com_naam', { ns: 'common' }),
                    sortable: true,
                    visible: true
                },
                {
                    key: 'opmerking',
                    label: this.$t('com_opmerking', { ns: 'common' }),
                    sortable: true,
                    visible: true
                }
            ];
            return fieldsInit.filter((field) => field.visible);
        },
        localObjects() {
            return this.inItems;
        }
    },
    methods: {
        reset() {
            this.detailsVisible = false;
        },
        changed() {
            this.$emit('changed', true);
        },
        async bewerkItem(item) {
            this.selectedExecutor = item ?? {};
            this.detailsVisible = !this.detailsVisible;
        },
        async verwijderItem(row) {
            const bericht =  this.$t('com_delete', {
                    ns: 'common',
                    val: this.$t('an_uitvoerder', { ns: 'analytics' })
                })  + row.naam;
            const doClose = await this.$root.showConfirmationBox(bericht);
            if (doClose) {
                await loadItem('analytics/deleteExecutor', {
                    executorID: row.id
                }, this.$t);
                this.changed();
            }
        },
        checkRight(recht) {
            const id = Permission.enum(recht);
            return this.$root.handleRight(id);
        }
    },
    mounted() {},
    created() {}
};
</script>

<style scoped></style>
